// Which side of the app an account belongs to. The login response and the
// session carry `side` ("admin" | "customer") — that is what decides which
// login / area an account may use, NOT the role's name. Only when `side` is
// missing (a backend that does not send it yet) does it fall back to the
// old rule: the role named "Customer" is the customer side.
export const isCustomerSide = ({ side, role } = {}) =>
  side === "customer" || side === "admin"
    ? side === "customer"
    : String(role || "").trim().toLowerCase() === "customer";
